import { NgModule } from '@angular/core';
import { AppSharedModule } from '@gestor-web/app/shared/modules';
import { CompetenciaComponent } from './competencia.component';

@NgModule({
  declarations: [CompetenciaComponent],
  exports: [CompetenciaComponent],
  imports: [AppSharedModule],
})
export class CompetenciaModule {}
